<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <img
          v-on="on"
          :src="icon"
          @click="openModal"
          width="30px"
          height="30px"
          alt=""
          class="md-image"
        />
      </template>
      <span>案件をフィルタする</span>
    </v-tooltip>
    <v-dialog v-model="dialog" persistent scrollable max-width="700px">
      <v-card>
        <v-card-title>
          <h3>表示させたい案件を選んでください</h3>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-btn
            v-if="!isSelectedAll"
            @click.native="selectAll"
            color="blue darken-1"
            flat
          >
            すべて選択
          </v-btn>
          <v-btn v-else @click.native="unSelectAll" color="blue darken-1" flat>
            選択を解除
          </v-btn>
          <v-checkbox
            v-for="datum in sortedItems"
            :key="datum.id"
            :value="datum.id"
            v-model="selected"
            hide-details
          >
            <template v-slot:label>
              <v-layout>
                <v-flex class="text-xs-no-wrap">{{ datum.name }}</v-flex>
                <v-flex class="text-xs-no-wrap ml-4">
                  <AppPeriod
                    :start="datum.ioBudgetStartTime"
                    :end="datum.ioBudgetEndTime"
                    empty-text=""
                  />
                </v-flex>
              </v-layout>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="onCancel">
            キャンセル
          </v-btn>
          <v-btn @click.native="onClickChange" color="primary">
            絞り込む
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sortBy from 'lodash/sortBy'
import { mapActions } from 'vuex'
import icon from '@/assets/images/filter-solid.svg'

export default {
  name: 'IOSelector',
  props: {
    reportData: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      selected: [],
      dialog: false,
    }
  },
  computed: {
    icon() {
      return icon
    },
    fetchedColor() {
      return this.$store.getters['colorTheme/color']
    },
    sortedItems() {
      return _sortBy(this.reportData, 'ioBudgetStartTime')
    },
    isSelectedAll() {
      return this.selected.length === this.reportData.length
    },
  },
  watch: {
    value() {
      this.selected =
        this.value == null ? this.reportData.map(d => d.id) : [...this.value]
    },
  },
  methods: {
    ...mapActions('advertiser/standardReport', {
      selectInsertionOrders: 'SELECT_INSERTION_ORDERS',
    }),
    async openModal() {
      this.dialog = true
    },
    async onCancel() {
      this.dialog = false
      this.selected = this.value
    },
    async onClickChange() {
      this.selectInsertionOrders(this.selected)
      this.dialog = false
    },
    selectAll() {
      this.selected = this.reportData.map(d => d.id)
    },
    unSelectAll() {
      this.selected = []
    },
  },
}
</script>

<style scoped></style>
